module.exports = "<p>\r\n  proteccion works!\r\n</p>\r\n"